export const eng = {
    dashboard: "Dashboard",

    accountsReceivable: "Accounts Receivable",
    customer: "Customer",
    inventory: "Inventory",
    product: "Product",


    quote: "Quote",
    payment: "Payment",
    employee: "Employee",
    admin: "admin",
    generalSettings: "General Settings",
    paymentMode: "Payment Mode",
    paymentInvoice: "Payment Invoice",
    role: "Role",
    settings: "Settings",
    //Customers...


    "customerForm": {
        "header": {
            "ADD_NEW_ENTITY": 'Add new customer',
            "DATATABLE_TITLE": 'customers List',
            "ENTITY_NAME": 'customer',
            "CREATE_ENTITY": 'Create customer',
            "UPDATE_ENTITY": 'Update customer',
            "PANEL_TITLE": 'Customer Panel',

        },
        "body" : {
            businessName: "Business Name",
            comercialDesignation: "Comercial Designation",
            codeClient: "code",
            name: "Name",
            surName: "Sur Name",
            email: "E-mail",
            phone: "phone",
            address:"Address"

        },
        "requiredMessages": {
            "name": "Please type your name !",
            "surName": "Please type your sur name !",
            "email": "Please type your email!",
            "phone": "Please type your phone number!",
            "message": "Please let us know how can we help you.",
            "country": "Please select a country."
        },
        "invalidMessages": {
            "email": "Email address is not valid!"
        },
    }


}